import { render } from "./Fees.vue?vue&type=template&id=5d196ae2"
import script from "./Fees.vue?vue&type=script&lang=js"
export * from "./Fees.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__